import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_STRING: "array_string",
    OBJECT: "object",
};

const contexts = {
    EVENT: "event",
    SYSTEM: "system",
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class CalendarModuleAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(
            this.eventCreated(),
            this.eventUpdated(),
            this.eventDeleted(),
            this.reservationCreated(),
            this.reservationDateChanged(),
            this.reservationDeleted()
        );
    }

    eventCreated() {
        const e = AutomationEventTypes.CALENDAR.EVENT_CREATED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Calendar Event Created", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.eventId`, "Event ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
            ]),
        ];
    }

    eventUpdated() {
        const e = AutomationEventTypes.CALENDAR.EVENT_UPDATED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Calendar Event Updated", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.eventId`, "Event ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.diff`, "Diff", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.diff.updatedFields`, "Updated Fields", vt.ARRAY_STRING),
                    ga(context, `${prefix}.diff.isSummaryChanged`, "Is Summary Changed", vt.BOOLEAN),
                    ga(context, `${prefix}.diff.isTypeChanged`, "Is Type Changed", vt.BOOLEAN),
                    ga(context, `${prefix}.diff.isStartDateChanged`, "Is Start Date Changed", vt.BOOLEAN),
                    ga(context, `${prefix}.diff.isEndDateChanged`, "Is End Date Changed", vt.BOOLEAN),
                ]),
            ]),
        ];
    }

    eventDeleted() {
        const e = AutomationEventTypes.CALENDAR.EVENT_DELETED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Calendar Event Deleted", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.eventId`, "Event ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
            ]),
        ];
    }

    reservationCreated() {
        const e = AutomationEventTypes.CALENDAR.RESERVATION_CREATED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Calendar Reservation Created", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.eventId`, "Event ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
            ]),
        ];
    }

    reservationDateChanged() {
        const e = AutomationEventTypes.CALENDAR.RESERVATION_DATE_CHANGED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Calendar Reservation Date Changed", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.eventId`, "Event ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.dates`, "Dates", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.dates.oldStartDate`, "Old Start Date", vt.DATE),
                    ga(context, `${prefix}.dates.oldEndDate`, "Old End Date", vt.DATE),
                    ga(context, `${prefix}.dates.newStartDate`, "New Start Date", vt.DATE),
                    ga(context, `${prefix}.dates.newEndDate`, "New End Date", vt.DATE),
                ]),
            ]),
        ];
    }

    reservationDeleted() {
        const e = AutomationEventTypes.CALENDAR.RESERVATION_DELETED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Calendar Reservation Deleted", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.eventId`, "Event ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
            ]),
        ];
    }
}

export default CalendarModuleAttributeFactory;
